import {
  type STImageMarker,
  type STMapMarker,
  type STMapMarkerFeature,
  type STMapMarkerPoint,
  type STMapMarkerScene,
  type STMapMarkerText,
  STMapMarkerType,
} from '@types';

export function isSTMarkerScene(
  marker: STImageMarker | STMapMarker
): marker is STImageMarker | STMapMarkerScene {
  // 如果marker.type为0或undefined, 则是场景标记
  if (marker.type === STMapMarkerType.scene || marker.type === undefined) {
    return marker.data.type === 0;
  }
  return false;
}

/** 是否是有标题高级设置的标记类型 */
export function isMapMarkerWithTitleSetting(
  marker: STMapMarker
): marker is STMapMarkerScene | STMapMarkerPoint | STMapMarkerText {
  const type = marker.type ?? STMapMarkerType.scene;
  return (
    type === STMapMarkerType.scene ||
    type === STMapMarkerType.point ||
    type === STMapMarkerType.text
  );
}

/** 是否是功能标记 */
export function isMapFeatureMarker(
  marker: STMapMarker
): marker is STMapMarkerFeature {
  if (marker.type === undefined) return false;
  if (marker.type === STMapMarkerType.scene) return false;
  if (marker.type === STMapMarkerType.pulse) return false;
  return marker.type in STMapMarkerType;
}
